// AccountHistoricService.jsx
import apiClient from './api';

const getMouvementsFinanciers = async (domainId, params = {}) => {
  const { 
    pageNumber = 1, 
    pageSize = 10,
    accountName = '',
    securityName = '',
    categorie = '',
    sortOrder = ''
  } = params;

  const queryParams = new URLSearchParams({
    pageNumber: pageNumber.toString(),
    pageSize: pageSize.toString(),
    ...(accountName && { accountName }),
    ...(securityName && { securityName }),
    ...(categorie && { categorie }),
    ...(sortOrder && { sortOrder })
  });

  const response = await apiClient.get(
    `/api/AccountHistoric/MouvementFinancier/${domainId}?${queryParams}`
  );
  
  return response.data;
};

export default getMouvementsFinanciers;